import PropTypes from 'prop-types';
import React from 'react';

import {
  IngredientAllergensInput,
  IngredientCategoryInput,
  IngredientIsStrategicAndEdibleInput,
  IngredientNameInput,
  IngredientUnityInput,
} from '@admin/products/ingredients/detail/components/IngredientInfo/common/inputs';

import { Container, InputContainer, InputsGrid } from './styledComponents';

const GRID_INPUTS = [
  IngredientNameInput,
  IngredientCategoryInput,
  IngredientUnityInput,
  IngredientAllergensInput,
];

/**
 * `isChildCreation` hides the category creation button, since opening another GenericModal would replace this one.
 */
const QuickCreateIngredientForm = ({
  ingredient,
  setIngredient,
  ingredientsCategories,
  availableAllergens,
}) => {
  const inputsContext = {
    ingredient,
    onIngredientChange: setIngredient,
    ingredientsCategories,
    availableAllergens,
    isChildCreation: true,
  };

  const renderInput = ({ component: InputComponent, props, keyProperty }) => (
    <InputComponent {...props(inputsContext)} value={ingredient[keyProperty] ?? ''} />
  );

  return (
    <Container>
      <InputsGrid>
        {GRID_INPUTS.map((input) => (
          <InputContainer key={input.keyProperty}>{renderInput(input)}</InputContainer>
        ))}
      </InputsGrid>
      {renderInput(IngredientIsStrategicAndEdibleInput)}
    </Container>
  );
};

QuickCreateIngredientForm.propTypes = {
  ingredient: PropTypes.object.isRequired,
  setIngredient: PropTypes.func.isRequired,
  ingredientsCategories: PropTypes.array.isRequired,
  availableAllergens: PropTypes.array.isRequired,
};

export default QuickCreateIngredientForm;
